import { ESCircularProgress } from '@energy-stacks/core/ui';
import { LogoOverlay } from '@energy-stacks/shared';
import { DarkLogo } from '@energy-stacks/theme';
import { Stack, useTheme } from '@mui/material';

export const FleetLogoOverlay = ({
  showSpinner,
}: {
  showSpinner?: boolean;
}) => {
  const { palette } = useTheme();
  return (
    <LogoOverlay
      logo={
        <Stack gap={10} alignItems="center" justifyContent="center">
          <DarkLogo />
          {showSpinner ? (
            <ESCircularProgress size="medium" color={palette.primary.light} />
          ) : null}
        </Stack>
      }
      backgroundColor={palette.dark.main}
    />
  );
};
